import { Box } from 'edenred-ui';
import styled from 'styled-components';

export const BoxWithShadow = styled(Box)`
  position: relative;
  background: white;
  padding: 16px;

  &::before {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: ${props => props.theme.sizeExtraExtraLarge};
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0),
      rgba(0, 0, 0, 0.05)
    );
  }
`;
